module.exports = __webpack_public_path__ + "media/failed.6f871bea.ogg";